import { defineComponent, PropType, ref, computed, onMounted, onBeforeUnmount, h } from 'vue'
import Plyr from 'plyr'
import { type Options as PlyrOptions } from 'plyr'

export default defineComponent({
  name: 'VuePlyr',
  props: {
    options: {
      type: Object as PropType<PlyrOptions>,
      required: false,
      default: () => ({})
    }
  },
  expose: ['getInstance', 'getElement'],
  emits: ['init'],
  setup (props, context) {
    let player: Plyr | null = null
    const el = ref<HTMLElement | null>(null)

    const opts = computed(() => {
      const options = props.options
      if (!('hideYouTubeDOMError' in options)) {
        // @ts-expect-error - hideYouTubeDOMError is not in the type definition
        options.hideYouTubeDOMError = true
      }
      return options
    })

    function getElement () {
      return el.value?.children.item(0) as HTMLElement
    }

    onMounted(() => {
      player = new Plyr(getElement(), opts.value)
      context.emit('init', player)
    })

    onBeforeUnmount(() => {
      try {
        player?.destroy()
      } catch (e: any) {
        // @ts-expect-error - hideYouTubeDOMError is not in the type definition
        if (!(opts.value.hideYouTubeDOMError && 'message' in e && e.message === 'The YouTube player is not attached to the DOM.')) {
          console.error(e)
        }
      }
    })

    return {
      el,
      getElement,
      getInstance: () => player
    }
  },
  render () {
    return h('div', {
      ref: 'el'
    }, this.$slots.default?.())
  }
})
